// client平台特有代码
// console.warn("platform:pc");
import Vue from 'vue'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueClipboard from 'vue-clipboard2'
import '@/less'
Vue.use(elementUI)
Vue.use(VueClipboard)
